<template>
  <li class="cart-nav onhover-dropdown">
    <div class="cart-box">
      <svg
        @click="manualBook_open()"
        :aria-busy="isLoading ? 'true' : 'false'"
        :class="{ loading: isLoading }"
        aria-label="Manual Book"
        role="img"
      >
        <title>Manual Book</title>
        <use href="@/assets/svg/icon-sprite.svg#book"></use>
      </svg>
      <span
        v-if="isLoading"
        class="spinner-border spinner-border-sm text-primary ms-2"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
  </li>
</template>

<script>
import ReferenceService from "@/services/reference/reference";

const getManual = ReferenceService.build();
export default {
  name: "ManualBook",
  data() {
    return {
      cart: false,
      isLoading: false,
    };
  },
  methods: {
    async manualBook_open() {
      this.isLoading = true;
      try {
        const res = await getManual.getManualBook();
        const contentDisposition = res.headers["content-disposition"] || "";
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const fileName = filenameMatch ? filenameMatch[1] : "Manual-Book.pdf";
        const tab = window.open("", "_blank");
        if (tab && tab.document) {
          tab.document.title = fileName;
          tab.document.body.style.margin = "0";
          const iframe = tab.document.createElement("iframe");
          iframe.src = url;
          iframe.style.border = "none";
          iframe.style.width = "100%";
          iframe.style.height = "100vh";
          tab.document.body.appendChild(iframe);
        } else {
          // Pop-up blocked, fallback to navigate current tab
          window.open(url, "_blank");
        }
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      } catch (e) {
        console.error("Manual Book open failed:", e);
        window.open("https://api-red.air.id/api/moonshot/ref/manual-book", "_blank");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.loading {
  cursor: progress;
  opacity: 0.8;
}
</style>
